import { useDisclosure } from "@mantine/hooks";
import { HiCheck, HiShare, HiArrowTopRightOnSquare } from "react-icons/hi2";
import { FaCheckCircle } from "react-icons/fa";
import { formatKES, getDisplayValue } from "../../../../utils/transactionutils";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import {
  ResultStatusIcon,
  TransactionDetailsCard,
} from "../../../shared/result/ResultPrimitives";
import { TransactionSummaryRows } from "./TransactionSummaryRows";
import { ReceiptModal } from "./ReceiptModal";

export function SuccessView({
  businessName,
  accountNumber,
  transactionAmount,
  transactionReference,
  transactionType,
  createdDate,
  verifiedAlias,
  aliasLabel,
  transactionFee,
  total,
  newBalance,
  status,
  mpesaReference,
  onNewPayment,
  onViewTransactions,
}) {
  const [receiptOpened, { open: openReceipt, close: closeReceipt }] =
    useDisclosure(false);

  return (
    <>
      <div className="flex flex-col items-center gap-6">
        <ResultStatusIcon
          icon={FaCheckCircle}
          bgClassName="bg-primary-50"
          iconClassName="text-primary-600"
        />

        <div className="text-center space-y-1">
          <p className="text-sm sm:text-base font-semibold text-green-600">
            Payment Successful !
          </p>
          <p className="text-3xl sm:text-4xl font-bold text-gray-900">
            {formatKES(transactionAmount)}
          </p>
        </div>

        <div className="text-center space-y-0.5">
          <div className="flex items-center justify-center gap-1.5">
            <p className="text-sm text-gray-600">
              Paid to:{" "}
              <span className="font-semibold text-gray-900">
                {getDisplayValue(businessName)}
              </span>
            </p>
            <HiCheck
              style={{ fontSize: 14 }}
              className="text-green-500 shrink-0"
            />
          </div>
          {accountNumber && (
            <p className="text-xs text-gray-500">Account: {accountNumber}</p>
          )}
        </div>

        <TransactionDetailsCard>
          <TransactionSummaryRows
            transactionReference={transactionReference}
            createdDate={createdDate}
            verifiedAlias={verifiedAlias}
            aliasLabel={aliasLabel}
            accountNumber={accountNumber}
            transactionAmount={transactionAmount}
            transactionFee={transactionFee}
            total={total}
            newBalance={newBalance}
          />
        </TransactionDetailsCard>

        <div className="w-full max-w-sm sm:max-w-md mx-auto space-y-2">
          <CustomButton
            fullWidth
            color="primary"
            radius="md"
            onClick={onNewPayment}
          >
            Make Another Payment
          </CustomButton>
          <div className="grid grid-cols-1 xs:grid-cols-2 gap-2">
            <CustomButton
              variant="outline"
              color="gray"
              radius="md"
              leftSection={<HiShare style={{ fontSize: 14 }} />}
              fullWidth
              onClick={openReceipt}
            >
              View Receipt
            </CustomButton>
            <CustomButton
              variant="outline"
              color="gray"
              radius="md"
              leftSection={<HiArrowTopRightOnSquare style={{ fontSize: 14 }} />}
              fullWidth
              onClick={onViewTransactions}
            >
              View in Transactions
            </CustomButton>
          </div>
        </div>
      </div>

      <ReceiptModal
        opened={receiptOpened}
        onClose={closeReceipt}
        transactionReference={transactionReference}
        transactionType={transactionType}
        businessName={businessName}
        status={status}
        mpesaReference={mpesaReference}
        verifiedAlias={verifiedAlias}
        aliasLabel={aliasLabel}
        accountNumber={accountNumber}
        transactionFee={transactionFee}
        total={total}
        newBalance={newBalance}
        createdDate={createdDate}
      />
    </>
  );
}
